<p-header> </p-header>

<ef-expense-detail-city-state-zip
    [states]="states$ | async"
    [cities]="cities$ | async"
    [countries]="countries$ | async"
    [areas]="areas$ | async"
    [locations]="locations$ | async"
    [locale]="locale"
    [selectedCity]="selectedCity"
    [selectedState]="selectedState"
    [selectedPostalCode]="selectedPostalCode"
    [selectedCountryArea]="selectedCountryArea"
    [selectedLocation]="selectedLocation"
    (SelectPostalCode)="onSelectPostalCode($event)"
    (SelectState)="onSelectState($event)"
    (SelectCountry)="onSelectCountry($event)"
    (Close)="onClose($event)"
    ([showAddressDialog])="(showAddressDialog)"
></ef-expense-detail-city-state-zip>
